import { type BadgeVariantType, ChartBadge } from '@/components/analytics/ChartBadge.tsx'
import { STORY_TYPE_COLORS } from '@/components/analytics/StoryCycleTimeOverview.tsx'
import { STORY_TYPE_CHART_ACTIVE_COLORS } from '@/constants/ANALYTICS.ts'
import { STORY_TYPES } from '@/constants/STORY_TYPES.ts'
import type { BarConfig, StackedBarChartConfig, StackedBarData, TooltipContentItem } from '@/types/chart'
import { formatToolTip, formatXAxisValue } from '@/utils/chart.ts'
import { toReadableDurationTime } from '@/utils/date.ts'
import type { ReactNode } from 'react'

const storyTypeBarConfig: BarConfig[] = [
  {
    key: 'feature',
    name: 'Feature',
    color: STORY_TYPE_COLORS[STORY_TYPES.FEATURE],
    activeColor: STORY_TYPE_CHART_ACTIVE_COLORS[STORY_TYPES.FEATURE],
  },
  {
    key: 'design',
    name: 'Design',
    color: STORY_TYPE_COLORS[STORY_TYPES.DESIGN],
    activeColor: STORY_TYPE_CHART_ACTIVE_COLORS[STORY_TYPES.DESIGN],
  },
  {
    key: 'chore',
    name: 'Chore',
    color: STORY_TYPE_COLORS[STORY_TYPES.CHORE],
    activeColor: STORY_TYPE_CHART_ACTIVE_COLORS[STORY_TYPES.CHORE],
  },
  {
    key: 'bug',
    name: 'Bug',
    color: STORY_TYPE_COLORS[STORY_TYPES.BUG],
    activeColor: STORY_TYPE_CHART_ACTIVE_COLORS[STORY_TYPES.BUG],
  },
]

const tooltipItems: TooltipContentItem<StackedBarData>[] = storyTypeBarConfig.map((bar) => ({
  label: bar.name,
  renderLabel: (label: string) => {
    return <ChartBadge variant={label as BadgeVariantType} value={label} />
  },
  valueKey: bar.key,
}))

const createChartConfig = (): StackedBarChartConfig => ({
  type: 'storiesAccepted',
  xFormatter: formatXAxisValue,
  bars: storyTypeBarConfig,
  tooltip: {
    renderHeader: (data: StackedBarData) => formatToolTip(data.iterationDate, data.iterationNumber),
    items: tooltipItems,
  },
})

const tooltipItemsForCycleTime: TooltipContentItem<StackedBarData>[] = storyTypeBarConfig.map((bar) => ({
  label: bar.name,
  renderLabel: (label: string) => {
    return <ChartBadge variant={label as BadgeVariantType} value={label} />
  },
  renderValue: (value: StackedBarData[keyof StackedBarData]) => {
    if (typeof value === 'number') {
      return toReadableDurationTime(value) as ReactNode
    }
    return ''
  },
  valueKey: bar.key,
}))

const createChartConfigForCycleTime = (): StackedBarChartConfig => ({
  type: 'storyCycleTime',
  xFormatter: formatXAxisValue,
  bars: storyTypeBarConfig,
  tooltip: {
    renderHeader: (data: StackedBarData) => formatToolTip(data.iterationDate, data.iterationNumber),
    items: tooltipItemsForCycleTime,
  },
})

export const STORIES_ACCEPTED_CONFIG = createChartConfig()
export const STORY_CYCLE_TIME_CONFIG = createChartConfigForCycleTime()
